/// <amd-module name="VC/Common/Flux/Store" />

import { Observable } from "VSS/Core/Observable";

export class Store {
    private observable = new Observable<void>();

    public subscribe(observer: () => void): void {
        this.observable.subscribe(observer, undefined);
    }

    public unsubscribe(observer: () => void): void {
        this.observable.unsubscribe(observer, undefined);
    }

    protected _emitChanged(): void {
        this.observable.notify(undefined, "emitChanged");
    }
}